import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendConfirmationForPromissory } from 'services/auth'

interface ISendAuthenticationPayload {
    phone_number: string
    code: string
}

const UseSendAuthentication = (
    setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>,
    mobile: string
) => {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendAuthenticationPayload) => {
            return sendConfirmationForPromissory(payload)
        },
        onSuccess: (data) => {
            if (data.two_factor_token) {
                navigate('/promissory/pay-for-promissory/', {
                    state: {
                        phone_number: mobile,
                        two_factor_token: data.two_factor_token,
                    },
                })
            } else {
                toast.success('احراز هویت انجام شد')
                navigate('/promissory/pay-for-promissory/')
            }
        },
        onError: () => {
            toast.error('کد وارد شده صحیح نمی باشد')
            setIsSubmit(false)
        },
    })

    return { isLoading, mutate }
}

export default UseSendAuthentication
